import { Component, OnInit } from '@angular/core';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';

@Component({
  selector: 'signout-redirect-callback',
  templateUrl: './signout-redirect-callback.component.html',
  styleUrls: ['./signout-redirect-callback.component.scss']
})
export class SignoutRedirectCallbackComponent implements OnInit {

  constructor(private oauthService: OAuthServiceService) { }

  ngOnInit() {
    this.oauthService.signOut();
    localStorage.removeItem('tenant-db');
    localStorage.removeItem('current-tenant-db');
    localStorage.removeItem('route-info');
    localStorage.removeItem('current-tenant-id');
    localStorage.removeItem('current-tenant-name');
    localStorage.removeItem('current-user-name');
   }
}
